import { Stack, Typography } from '@mui/material';
import { useCallback, useRef, useState } from 'react';
import { IconSvg } from '@/components/Icon';
import LoadingButton from '@/components/LoadingButton';
import { ConfirmationCodeInput } from '@/components/confirmation-code-input';
import OtpTimer from '@/components/timer/OtpTimer';
type Props = {
  sendOtp: () => void;
  verifyOtp: (code: string) => void;
  otpTimeout: string;
  sendOtpLoading: boolean;
  verifyOtpLoading: boolean;
  isSuccess: boolean;
};
const RequestSejamVerifyOtp = (props: Props) => {
  const [error, setError] = useState(false);
  const [isFinished, setIsFinished] = useState(new Date().getTime() > +props.otpTimeout);
  const [firstTime, setFirstTime] = useState(false);
  const otpInputRef = useRef({
    value: ''
  });
  const onDone = useCallback(() => {
    if (!props.verifyOtpLoading) {
      setFirstTime(false);
      setIsFinished(true);
    }
  }, []);
  return <Stack alignItems='center' sx={{
    px: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_xl)'
    }
  }} data-sentry-element="Stack" data-sentry-component="RequestSejamVerifyOtp" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
      <Stack alignItems='center' sx={{
      width: '100%',
      fontSize: {
        xs: 56,
        md: 72
      },
      py: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_l)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
        <IconSvg component='Otp' data-sentry-element="IconSvg" data-sentry-source-file="RequestSejamVerifyOtp.tsx" />
      </Stack>

      <Stack gap='var(--spacing_s)' data-sentry-element="Stack" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
        <Typography textAlign={{
        xs: 'center',
        md: 'start'
      }} component='div' typography='bodyRegular__Wallfund' data-sentry-element="Typography" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
          کد تایید به شماره موبایلی که در حساب{' '}
          <Typography component='span' typography='bodyStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
            سجام
          </Typography>{' '}
          خود ثبت کرده‌اید، ارسال شد.
        </Typography>

        <ConfirmationCodeInput inputCount={5} onComplete={value => {
        props.verifyOtp(value);
      }} onError={() => setError(true)} error={error} ref={otpInputRef} data-sentry-element="ConfirmationCodeInput" data-sentry-source-file="RequestSejamVerifyOtp.tsx" />

        <OtpTimer sendOtpDisabled={props.sendOtpLoading || props.verifyOtpLoading} handleSendOtp={props.sendOtp} onDone={onDone} otpTimeout={props.otpTimeout} loading={props.sendOtpLoading} isFirstTime={firstTime} isFinished={isFinished} data-sentry-element="OtpTimer" data-sentry-source-file="RequestSejamVerifyOtp.tsx" />
      </Stack>

      <Stack sx={{
      width: '100%',
      pt: 'var(--spacing_m)',
      pb: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_xl)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
        <LoadingButton fullWidth onClick={() => props.verifyOtp(otpInputRef?.current?.value)} disabled={props.sendOtpLoading || props.verifyOtpLoading || props.isSuccess} loading={props.verifyOtpLoading} color='primary' variant='contained' size='large' data-sentry-element="LoadingButton" data-sentry-source-file="RequestSejamVerifyOtp.tsx">
          تایید
        </LoadingButton>
      </Stack>
    </Stack>;
};
export default RequestSejamVerifyOtp;